<template>
    <div>
        <div :class="['bottom-panel', { expanded }]">
            <div class="toggle-button" @click="togglePanel">
                <img :src="require(`@/assets/images/shape.svg`)" class="wave">
                <div class="icon-wrapper">
                    <i v-if="!expanded" class="fa fa-chevron-up"></i>
                    <i v-else class="fa fa-chevron-down"></i>
                </div>
            </div>
            <div class="panel-content" v-show="expanded">
                <div class="container">
                    <div class="lead-details">
                        <div class="lead-detail">
                            <h4 class="mb-2">Route Tools</h4>
                            <div class="d-flex" v-if="!hasRouteMissingFields">
                                <b-button-group size="sm" class="my-1">
                                    <a title="25 Miles Around" class="btn border-left-pill btn-secondary"
                                        target="_blank" rel="noreferrer noopener" :href="getCDLink(25)">
                                        <i class="fas fa-angle-right"></i>
                                    </a>
                                    <a title="50 Miles Around" class="btn btn-secondary" target="_blank"
                                        rel="noreferrer noopener" :href="getCDLink(50)">
                                        <i class="fas fa-angle-double-right"></i>
                                    </a>
                                    <a title="100 Miles Around" class="btn border-left-pill btn-secondary"
                                        target="_blank" rel="noreferrer noopener" :href="getCDLink(100)">
                                        <i class="fas fa-angle-right"></i>
                                        <i style="margin-left: -0.28rem" class="fas fa-angle-double-right"></i>
                                    </a>
                                </b-button-group>
                                <div class="my-1 pl-3">
                                    <i class="fas fa-map-marked-alt route" style="font-size:24px;"
                                        @click="handleRouteClicked"></i>
                                </div>
                            </div>
                            <div v-else>
                                <div class="mt-2 alert alert-warning">
                                    Fill route details first.
                                </div>
                            </div>
                        </div>
                        <div class="lead-detail">
                            <h4 class="mb-2">Price Details</h4>
                            <template>
                                <div v-if="!hasRouteMissingFields">
                                    <div v-for="(vehicle, index) in formFields.vehicles" :key="index">
                                        <VehicleCalculation :pickup="formFields.pickupLocation.zip"
                                            :delivery="formFields.deliveryLocation.zip" :vehicle="vehicle.vehicleTypeId"
                                            :index="index" />
                                    </div>
                                </div>
                                <div v-else>
                                    <div class="mt-2 alert alert-warning">
                                        Fill route details first.
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <RouteMapModal id="cardRouteModal" :route="routeInfo" />
    </div>
</template>

<script>
import RouteMapModal from '@/components/shared/route/RouteMapModal';
import VehicleCalculation from '@/components/shared/bottombar/VehicleCalculation';

export default {
    name: "BottomPanel",
    components: {
        RouteMapModal,
        VehicleCalculation,
    },
    props: {
        formFields: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            expanded: false,
            routeInfo: { id: '#', origin: null, destination: null, infoHtml: null },
        };
    },
    computed: {
        hasRouteMissingFields() {
            const { pickupLocation, deliveryLocation } = this.formFields;

            return !pickupLocation.city ||
                !pickupLocation.state ||
                !pickupLocation.zip ||
                !deliveryLocation.city ||
                !deliveryLocation.state ||
                !deliveryLocation.zip;
        },
    },
    methods: {
        handleKeyDown(e) {
            if (e.key === 'Shift') {
                this.expanded = true;
            }
        },
        handleKeyUp(e) {
            if (e.key === 'Shift') {
                this.expanded = false;
            }
        },
        togglePanel() {
            this.expanded = !this.expanded;
        },

        getCDLink(distance) {
            let url = 'https://app.centraldispatch.com/search?search=' +
                '~(vC~(mn~1)~tLPW~2~opt~%27all~ofst~0~lmt~50~sF~(~(n~%27pup~d~%27ASC)~(n~%27dMA~d~%27ASC))~dBS~false~sPSO~false~sTOT~false~rT~%27Open~l~(~(c~%27' +
                this.formFields.pickupLocation.city?.replace(' ', '*20') +
                '~st~%27' +
                this.formFields.pickupLocation.state +
                //'~zC~%27'+
                //this.lead.pickupLocation.zip +
                '~r~' +
                distance +
                '~s~%27Pickup)~(c~%27' +
                this.formFields.deliveryLocation.city?.replace(' ', '*20') +
                '~st~%27' +
                this.formFields.deliveryLocation.state +
                //'~zC~%27' +
                //this.lead.deliveryLocation.zip +
                '~r~' +
                distance +
                '~s~%27Dropoff)))';
            return url;
        },
        handleRouteClicked() {
            const { id, pickupLocation, deliveryLocation } = this.formFields;
            this.routeInfo = {
                id,
                origin: `${pickupLocation.city}, ${pickupLocation.state}, ${pickupLocation.zip}`,
                destination: `${deliveryLocation.city}, ${deliveryLocation.state}, ${deliveryLocation.zip}`,
                infoHtml: `(A) ${pickupLocation.city}, ${pickupLocation.state.toUpperCase()}, ${pickupLocation.zip}<i class="mx-1 fa-lg fas fa-shipping-fast"></i>(B) ${deliveryLocation.city
                    }, ${deliveryLocation.state.toUpperCase()}, ${deliveryLocation.zip}`,
            };
            this.$bvModal.show('cardRouteModal');
        },
    },
    mounted() {
        window.addEventListener('keydown', this.handleKeyDown);
        window.addEventListener('keyup', this.handleKeyUp);
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.handleKeyDown);
        window.removeEventListener('keyup', this.handleKeyUp);
    },
};
</script>

<style scoped lang="scss">
.lead-details {
    display: flex;
    justify-content: space-between;

    .lead-detail {
        flex-basis: 49%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
}

.bottom-panel {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    transition: all 0.3s ease;
    z-index: 1000;

    .route {
        cursor: pointer;
    }

    &.expanded {
        bottom: -20px;

        .wave {
            top: -9px;
        }

        .toggle-button {
            .icon-wrapper {
                top: -6px;
            }
        }

        .panel-content {
            box-shadow: 0px 0px 10px #00000030;
        }
    }

    .toggle-button {
        text-align: center;
        position: relative;

        .icon-wrapper {
            cursor: pointer;
            position: absolute;
            left: 50%;
            transform: translate(-50%);
            color: #fff;
            top: -5px;
        }
    }
}

.wave {
    position: relative;
    top: -3px;
    cursor: pointer;
    scale: 2;
}

.bottom-panel:not(.expanded) {
    height: 15px;
}

.bottom-panel.expanded {
    height: 160px;
}

.panel-content {
    backdrop-filter: blur(100px);
    padding: 15px;
    overflow-y: auto;
    height: calc(100% - 40px);
}
</style>